import { getDefaultSliderSettings, handleAutoplay } from '../utils/slider.js';
import { Swiper } from './swiper-src.min.js';

export default function initContainerFeatureSlider() {
  const swiperContainer = document.querySelector('.container-feature .swiper');
  if (!swiperContainer) return;

  const paginationAria = swiperContainer
    .querySelector('.swiper-pagination')
    .getAttribute('data-aria-pagination-bullet');

  new Swiper(swiperContainer, {
    ...getDefaultSliderSettings(swiperContainer),
    autoplay: {
      delay: 7000,
      pauseOnMouseEnter: false
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
      renderBullet: (index, className) => {
        const bullet = document.createElement('button');
        bullet.className = className;
        bullet.setAttribute('aria-label', `${paginationAria} ${index + 1}`);
        return bullet.outerHTML;
      }
    },
    on: {
      afterInit: function (slider) {
        const controlBtn = document.querySelector('.play-pause-button-control');
        handleAutoplay(controlBtn, slider);

        controlBtn?.addEventListener('click', () => {
          updatePausedBullets();
        });

        const updatePausedBullets = () => {
          document.querySelectorAll('.swiper-pagination-bullet').forEach(bullet => {
            bullet.classList.remove('is-paused');
          });
          if (!slider.autoplay.running) {
            document.querySelectorAll('.swiper-pagination-bullet-active').forEach(bullet => {
              bullet.classList.add('is-paused');
            });
          }
        };

        // Initial state
        updatePausedBullets();
        // Expose for use in other events
        slider.updatePausedBullets = updatePausedBullets;
      },
      slideChange: function (slider) {
        // On slide change, update bullets if paused
        if (typeof slider.updatePausedBullets === 'function') {
          slider.updatePausedBullets();
        }
      },
      paginationRender: () => {
        swiperContainer.querySelectorAll('.swiper-pagination-bullet').forEach(el => {
          el.setAttribute('tabindex', '-1');
        });
      },
      paginationUpdate: () => {
        swiperContainer.querySelectorAll('.swiper-pagination-bullet').forEach(el => {
          el.setAttribute('tabindex', '-1');
        });
      }
    }
  });
}
